import { apiClient } from '@services/api-client'
import { BACK_OFFICE_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import type { ScheduledTask } from '@features/cron/types'

export function useScheduledTask(id?: string) {
  async function getScheduledTask(): Promise<ScheduledTask> {
    const res = await apiClient.get<ScheduledTask>(
      `${BACK_OFFICE_PREFIX}scheduled-tasks/${id}`
    )
    return res.data
  }

  return useQuery({
    queryFn: getScheduledTask,
    queryKey: ['scheduled-task', id],
    enabled: !!id
  })
}
